var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isResult
      ? _c("div", [_c("Result")], 1)
      : _c(
          "div",
          [
            _c("div", { staticClass: "modal__shindanContent" }, [
              _c(
                "div",
                { staticClass: "modal__shindanContentCell" },
                [_c("Quasution")],
                1
              ),
            ]),
            _vm._v(" "),
            _c("Bar"),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }